import React, { Component } from 'react';
import './CalendarMonth.css';

class CalendarMonth extends Component {

	render() {
		return(
			<div className={'CalendarMonth month-' + this.props.month.id} key={this.props.month.id}>
				<div className="CalendarMonth-title">{this.props.month.title}</div>
				<div className="CalendarMonth-table">
					<div className="head">
						<div className="CalendarMonthCell"><div className="CalendarMonthCell-content"><span>KW</span></div></div>
						<div className="CalendarMonthCell"><div className="CalendarMonthCell-content"><span>MO</span></div></div>
						<div className="CalendarMonthCell"><div className="CalendarMonthCell-content"><span>DI</span></div></div>
						<div className="CalendarMonthCell"><div className="CalendarMonthCell-content"><span>MI</span></div></div>
						<div className="CalendarMonthCell"><div className="CalendarMonthCell-content"><span>DO</span></div></div>
						<div className="CalendarMonthCell"><div className="CalendarMonthCell-content"><span>FR</span></div></div>
						<div className="CalendarMonthCell"><div className="CalendarMonthCell-content"><span>SA</span></div></div>
						<div className="CalendarMonthCell"><div className="CalendarMonthCell-content"><span>SO</span></div></div>
					</div>
					<div className="body">
						{this.props.children}
					</div>
				</div>
			</div>
		)
	}
}

export default CalendarMonth;



// WEBPACK FOOTER //
// ./src/components/CalendarMonth.js